const content = {
  report_types: [
    {
      text: "EN50160 Compliance",
      id: "ScavengerEN50160Report",
      icon: "mdi-wifi",
    },
    {
      text: "IEC61000",
      id: "ScavengerIEC61000Report",
      icon: "mdi-bluetooth",
    },
    {
      text: "Harmonics",
      id: "ScavengerHarmonicsReport",
      icon: "mdi-signal",
    },
    // {
    //   icon: "mdi-chart-donut",
    //   id: "ScavengerCustomizeReport",
    //   text: "Customize",
    // },
  ],
  phases: ["l1", "l2", "l3"],
  value_keys: ["minVal", "meanVal", "maxVal"],
  frequency_limits: [
    {
      min: "49.5",
      max: "50.5",
    },
    {
      min: "47",
      max: "52",
    },
  ],
  flicker_severity_limits: {
    min: "0.0",
    max: "10",
  },
  vRms_limits: [
    {
      min: "207",
      max: "253",
    },
    {
      min: "195.5",
      max: "253",
    },
  ],
  vThd_limits: [
    {
      min: "0",
      max: "8",
    },
  ],
  sections: [
    {
      label: "Power Frequency",
      icon: "mdi-sine-wave",
      id: "frequency",
    },
    {
      label: "Supply Voltage Variation",
      icon: "mdi-swap-vertical",
      id: "vRms",
    },
    {
      label: "Flicker Severity",
      icon: "mdi-waveform",
      id: "flicker_severity",
    },
    {
      label: "THDS",
      icon: "",
      id: "vThd",
    },
  ],
  en50160_report: [
    {
      label: "Supply Voltage Variation",
      key: "vRms",
      data: [
        {
          perc: 95,
          min: 207,
          max: 253,
          lines: ["L1", "L2", "L3"],
        },
        {
          perc: 100,
          min: 195.5,
          max: 253,
          lines: ["L1", "L2", "L3"],
        },
      ],
      total: "vThd_vRms_total",
      summary_key: "voltage_variation",
    },
    {
      label: "Flicker Severity",
      key: "flicker_severity",
      data: [
        {
          perc: 95,
          min: 0,
          max: 1,
          lines: ["L1", "L2", "L3"],
        },
      ],
      total: "flicker_total",
      summary_key: "flicker_severity",
    },
    {
      label: "Frequency",
      key: "frequency",
      data: [
        {
          perc: 99.5,
          min: 49.5,
          max: 50.5,
        },
        {
          perc: 100,
          min: 47,
          max: 52,
        },
      ],
      total: "data_total",
      summary_key: "power_frequency",
    },
    {
      label: "Total Harmonics Distortion",
      key: "vThd",
      data: [
        {
          perc: 95,
          min: 0,
          max: 8,
          lines: ["L1", "L2", "L3"],
        },
      ],
      total: "vThd_vRms_total",
      summary_key: "thds",
    },
  ],
  en50160_report_chips: {
    pass: {
      color: "noIssuesBackground",
      textColor: "noIssuesText",
      label: "Pass",
      tooltip: "Compliant / Healthy State",
    },
    caution: {
      color: "cautionBackground",
      textColor: "cautionText",
      label: "Caution",
      tooltip: "Borderline / Low Margin",
    },
    failed: {
      color: "alarmBackground",
      textColor: "alarmText",
      label: "Failed",
      tooltip: "Violated Metric",
    },
    info: {
      color: "checkDeviceBackground",
      textColor: "checkDeviceText",
      label: "",
      tooltip: "",
    },
  },
  harmonics_category: [
    [5, 7, 11, 13, 17, 19, 23, 25],
    [3, 9, 15, 21],
    [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24],
  ],
  harmonics_limit: [
    2, // 0: H2
    5, // 1: H3
    1, // 2: H4
    6, // 3: H5
    0.5, // 4: H6
    5, // 5: H7
    0.5, // 6: H8
    1.5, // 7: H9
    0.5, // 8: H10
    3.5, // 9: H11
    0.5, // 10: H12
    3, // 11: H13
    0.5, // 12: H14
    1, // 13: H15
    0.5, // 14: H16
    2, // 15: H17
    0.5, // 16: H18
    1.5, // 17: H19
    0.5, // 18: H20
    0.75, // 19: H21
    0.5, // 20: H22
    1.5, // 21: H23
    0.5, // 22: H24
    1.5, // 23: H25
  ],
  en61000_report: {
    transformer_details: [
      {
        label: "Transformer ID",
        value: "DeviceID",
      },
      {
        label: "Transformer Location",
        value: "TransformerLocation",
      },
      {
        label: "Transformer Coordinates",
        value: "TransformerCoordinates",
      },
      {
        label: "Transformer Rating",
        value: "TransformerRating",
      },
      {
        label: "Feeders Connected",
        value: "FeedersConnected",
      },
      {
        label: "Area Rating",
        value: "AreaRating",
      },
    ],
  },
  en61000_intervals: [
    {
      label: "3 mins",
      value: 1800,
    },
    {
      label: "10 mins",
      value: 600000,
    },
    {
      label: "2 hours",
      value: 7200000,
    },
  ],
  harmonics_bar_chart_title: [
    "H02",
    "H03",
    "H04",
    "H05",
    "H06",
    "H07",
    "H08",
    "H09",
    "H10",
    "H11",
    "H12",
    "H13",
    "H14",
    "H15",
    "H16",
    "H17",
    "H18",
    "H19",
    "H20",
    "H21",
    "H22",
    "H23",
    "H24",
    "H25",
  ],
  harmonics_bar_chart: {
    id: "scavenger_harmonics_bar_chart",
    label: "Harmonics",
    suffix: "A",
    type: "stacked",
    xAxis: "Harmonics",
    yAxis: "Value",
  },
  harmonics_bar_chart_legends: [
    {
      id: "limit",
      label: "Limit",
      color: "#c6ced4",
    },
    {
      id: "perc_95",
      label: "Percentile 95",
      color: "#42f55d",
    },
    {
      id: "mean",
      label: "Mean",
      color: "#4275f5",
    },
  ],
};

export { content };
